module.exports = __webpack_public_path__ + "static/media/CLEANING.06be29e0.svg";